module.exports = __webpack_public_path__ + "img/one_15.28f1d0f7.jpg";